// extracted by mini-css-extract-plugin
export default {"overlay":"Loading_overlay__yljD-","overlayFadeIn":"Loading_overlayFadeIn__KUNP2","spinner":"Loading_spinner__YFlPV","spin":"Loading_spin__yMiv4","label":"Loading_label__+e40p"};